var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-flex tw-flex-1 tw-flex-col tw-overflow-y-auto tw-p-6 tw-scrollbar-minimal",style:({ maxHeight: _setup.maxHeight, minHeight: _setup.minHeight })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }